import { c as _c } from "react/compiler-runtime";
import { type WaterSource } from "@/types/water-source";
export function WaterSource(t0) {
  const $ = _c(10);
  const {
    waterSource,
    fallback,
    className
  } = t0;
  if (!waterSource) {
    let t1;
    if ($[0] !== className || $[1] !== fallback) {
      t1 = <div className={className}>{fallback}</div>;
      $[0] = className;
      $[1] = fallback;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let sources;
  if ($[3] !== waterSource.borewell || $[4] !== waterSource.supply || $[5] !== waterSource.tanker) {
    sources = [];
    if (waterSource.supply === "yes") {
      sources.push("Supply (Cauvery)");
    }
    if (waterSource.borewell === "yes") {
      sources.push("Borewell");
    }
    if (waterSource.tanker === "yes") {
      sources.push("Tanker");
    }
    $[3] = waterSource.borewell;
    $[4] = waterSource.supply;
    $[5] = waterSource.tanker;
    $[6] = sources;
  } else {
    sources = $[6];
  }
  if (!sources.length) {
    return null;
  }
  const t1 = sources.join(", ");
  let t2;
  if ($[7] !== className || $[8] !== t1) {
    t2 = <div className={className}>{t1}</div>;
    $[7] = className;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}